<template>
  <v-layout
    align-center
    :column="isZkm && $vuetify.breakpoint.xsOnly"
    :class="
      activeStep === 1
        ? 'card-header-ticket'
        : ['card-header-ticket card-header-other', isZkm && 'card-header-other-zkm']
    "
    :style="{ borderTopLeftRadius: event.cover && '0', borderTopRightRadius: event.cover && '0' }"
  >
    <v-flex v-if="isZkm" class="header-container">
      <v-layout column wrap>
        <v-flex xs12 style="color: #333" class="event-title event-title-zkm">
          {{ event.title }}
        </v-flex>
        <span id="event-date">
          {{ formatDate(event.from) }}
        </span>
        <v-flex xs12 class="header-description">
          <span>{{ textStyles.hostedBy || $t('hostedBy') }}</span>
          <span style="color: #333">
            {{ event.organization.publicName }}
          </span>
          <span v-if="event.location && event.location.venue">{{ textStyles.at || $t('at') }}</span>
          <span v-if="event.location && event.location.venue" style="color: #333">
            {{ event.location.venue }}
          </span>
          <span>{{ textStyles.at || $t('at') }}</span>
          <span style="color: #333">
            {{ parseTime(event.from) }}
          </span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-layout
      v-else
      row
      wrap
      :class="['event-data-container', !isZkm && 'event-data-container-regular']"
    >
      <div v-if="event.id !== '1714'" class="event-data">
        <span id="event-date" class="event-data-item">
          {{ formatDate(event.from, !isSameDate()) }}
          {{ !isSameDate() ? ` - ${formatDate(event.to, !isSameDate())}` : '' }}
        </span>
        <span class="event-data-item-title">
          {{ event.title }}
        </span>
        <span
          v-if="event.location && event.location.venue === 'Ljetno Art-kino'"
          class="event-data-item"
        >
          {{ event.location.venue }}
        </span>
        <span v-else class="event-data-item">
          {{ event.organization.publicName }}
        </span>
      </div>
      <div v-else class="event-data" style="display: flex; flex-direction: column; gap: 0.5rem">
        <span class="event-data-item-title" style="font-family: NouvelR-Regular">
          {{ event.title }}
        </span>
        <span
          id="event-date"
          class="event-data-item"
          style="font-family: NouvelR-Regular; font-size: 1rem"
        >
          11 - 13 Mar 2024
        </span>
        <div>
          <span
            class="event-data-item custom-subtitle"
            style="font-family: NouvelR-Regular; font-size: 1.25rem; margin: 0"
          >
            Rixos Premium Dubrovnik
          </span>
          <span
            class="event-data-item custom-subtitle"
            style="font-family: NouvelR-Regular; font-size: 1.25rem"
          >
            Dubrovnik, Croatia
          </span>
        </div>
      </div>
      <div
        v-if="!isZkm && event.organization.logo && event.id !== '1714'"
        class="organization-logo-container"
      >
        <img alt="organization logo" class="organization-logo" :src="event.organization.logo" />
      </div>
    </v-layout>
  </v-layout>
</template>
<script>
import moment from 'moment'
import i18next from 'i18next'
import { isHNBOrganization } from '@/utils'

export default {
  name: 'card-header',
  props: {
    event: Object,
    textStyles: {
      type: Object,
      default: () => ({}),
    },
    activeStep: Number,
  },
  computed: {
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
  },
  watch: {
    '$i18next.language': function () {
      const eventDate = this.isZkm
        ? this.formatDate(this.event.from)
        : this.formatDate(this.event.from, !this.isSameDate()) +
          (!this.isSameDate() ? ` - ${this.formatDate(this.event.to, !this.isSameDate())}` : '')
      document.getElementById('event-date').innerHTML = eventDate
    },
  },
  methods: {
    parseTime(date) {
      return moment(date).format('HH:mm')
    },
    isSameDate() {
      return moment(this.event.to).isSame(moment(this.event.from), 'day')
    },
    formatDate(timestamp, hideHours) {
      const lan = i18next.language
      moment.locale(lan)
      if (hideHours || isHNBOrganization(this.event.organization.id)) {
        return moment(timestamp).format('D. MMM YYYY')
      }

      return moment(timestamp).format(`D. MMM YYYY ${lan === 'hr' ? '[u]' : '[at]'} HH:mm`)
    },
  },
}
</script>

<style scoped>
.header-date-container {
  margin-right: 32px;
}

.card-header-ticket {
  display: flex;
  background-color: transparent !important;
  padding: 1rem 1.5rem;
  align-items: flex-start;
  gap: 1rem;
  border-radius: 4px;
  border: 1px solid rgba(151, 151, 151, 0.5);
}

.header-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  color: #979797;
  padding-top: 0 !important;
  line-height: 1.2;
  display: block;
  padding-right: 20px !important;
  margin-top: 8px;
  color: #333333;
}

.event-title {
  font-family: Raleway, sans-serif;
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 10px;
  overflow-wrap: break-word;
}

.event-title-zkm {
  color: #333333 !important;
}

.card-header-other {
  border-radius: 8px;
}

.card-header-other-zkm {
  background-color: transparent !important;
  border: solid #333;
  border-width: 2px 0;
  border-radius: 0px !important;
  margin-bottom: 0;
}

@media screen and (max-width: 992px) and (min-width: 801px) {
  .card-header-ticket {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    border-radius: 8px;
  }
}

@media (max-width: 599px) {
  .header-date-container {
    margin-right: auto;
    padding-bottom: 16px;
  }

  .header-container {
    width: 100%;
  }
}

@media (min-width: 992px) and (max-width: 1440px) {
  .card-header-other {
    border-radius: 8px 0 0 8px;
  }
}

@media screen and (max-width: 415px) {
  .card-header-other {
    max-width: 250px;
    margin: 0 auto 24px;
  }
}

.event-data {
  display: flex;
  flex-direction: column;
  max-width: 73%;
}

.event-data-item {
  display: block;
  color: #333;
  font-family: Source Sans Pro;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.event-data-item-title {
  display: block;
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  word-break: break-word;
  hyphens: auto;
}

.organization-logo-container {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.organization-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.event-data-container-regular {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.custom-subtitle {
  font-family: NouvelR-Extrabold;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 150%;
  letter-spacing: -0.03em;
  color: $color-grey;
  margin-bottom: 1.5rem;
}
</style>
